import { httpRequest } from "../../http";
import type { IngestRun } from "@models/IngestRun.model";

export class CommandMarkUploadFailed {
  async run(fileId: number, message: string): Promise<IngestRun> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${fileId}/mark-upload-failed/`;
    return httpRequest<IngestRun>(url, { method: "POST", body: { message } });
  }
}
